import styled from 'styled-components';

export const Wrapper = styled.a`
  position: fixed;
  right: 2rem;
  bottom: 2rem;
  z-index: 9999;

  width: 72px;
  height: 72px;
  border-radius: 50%;

  display: flex;
  align-items: center;
  justify-content: center;

  background: #fff;
  box-shadow: 0 0px 14px rgba(0, 0, 0, 0.4);
  cursor: pointer;

  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 18px 34px rgba(0, 0, 0, 0.22);
  }

  @media (max-width: 600px) {
    right: 1.25rem;
    bottom: 1.25rem;
    width: 64px;
    height: 64px;
  }
`;

export const Icon = styled.img`
  width: 34px;
  height: 34px;
  object-fit: contain;

  @media (max-width: 600px) {
    width: 30px;
    height: 30px;
  }
`;
